import logoPNG from '../assets/img/logo.png';
export default function LoadingPage() {
    return (
        <div className="style-container-loading-page">

            <div className='d-flex flex-column align-items-center text-center'>
                <img src={logoPNG} alt="Apito" className='style-size-image-logo-loading-page' />
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div className='text-light style-fs-text-loading-page'>
                    Aguarde enquanto<br />carregamos a página...
                </div>
            </div>
        </div>
    )
}